import { render, staticRenderFns } from "./IrregularVerbsModal.vue?vue&type=template&id=5f857fa6&scoped=true&"
import script from "./IrregularVerbsModal.vue?vue&type=script&lang=js&"
export * from "./IrregularVerbsModal.vue?vue&type=script&lang=js&"
import style0 from "./IrregularVerbsModal.vue?vue&type=style&index=0&id=5f857fa6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f857fa6",
  null
  
)

export default component.exports